import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  headerStyling: {
    backgroundColor: "#fff5e3",
    textAlign: "center",
    padding:"5px 0 5px 0"
  },
  headerTitle: {
    width: "100%",
    margin: "5px auto",
    fontWeight: 500,
  },
  modalContentParent: {
    padding: "30px 10px 10px 10px",
  },
  modalBottomText: {
    display: "block",
  },
  buttonsParent: {
    textAlign: "center",
    margin: "20px 0 10px 0",
  },
  buttonsColor: {
    color: "#000000",
  },
}));

export default useStyles;